export default __webpack_public_path__ + "static/media/RGC_Logo22.4ce2ea5f.png";